import Layout from "../../components/Layout";
import { PaymentsNavigationTabs } from "../../components/NavigationTabs/PaymentsNavigationTabs";
import Table from "../../components/Table";

export default function HostedPaymentPages() {
  return (
    <Layout metaTitle="Hosted Payment Pages">
      <Table
        url="/d/hpp/"
        formURL="/d/hpp/form/"
        tableName="Hosted Payment Page"
        tableDescription="Create a hosted payment page that contains a context for intents with minimal configuration."
        navigationTabs={
          <PaymentsNavigationTabs activeTab="hostedPaymentPages" />
        }
      />
    </Layout>
  );
}

HostedPaymentPages.parentPath = "/hosted-payment-pages";
